export const INSERT_CODE_BLOCK_BUTTON = 'insert-code-block-button';
export const TEXT_BUTTON_CODE_BLOCK = 'text-button-code-block';
export const ROOT = 'code-block';
